import moment from "moment/moment";
import React, { Fragment } from "react";
import styles from "./OperatorGuideLines.module.css";

const isServiceNotApplicable = ({helpNotes}) =>{
    return (helpNotes?.rules?.is_service_available_at_center===false || helpNotes?.rules?.is_service_not_handled_by_ai === true);
}
const ServiceNotForBooking = ({ helpNotes }) => {
    return (<div style={{ display: "grid", gap: "1px", margin: "3px", padding: "3px", backgroundColor: "coral", fontSize: "14px", color: "white" }}>
        {/* service not available */}
        {helpNotes?.rules?.is_service_available_at_center===false && <li>Service is not availabile at center.</li>}
        {/* service not available */}
        {helpNotes?.rules?.is_service_not_handled_by_ai === true && <li>Service cannot be handled by Olivia.</li>}
    </div>)
}

const CheckHelpNotes=({helpNotes})=>{

let service_cost=helpNotes?.rules?.non_bulk_bill_data?.service_cost
let gap_cost=helpNotes?.rules?.non_bulk_bill_data?.gap
let additional_cost=0
if(Object.keys(helpNotes?.rules?.non_bulk_bill_data_for_specific_day).length>0)
{
additional_cost=helpNotes?.rules?.non_bulk_bill_data_for_specific_day.gap
}
let show=false;
if(service_cost > 0 || gap_cost > 0 || additional_cost > 0)
{
    show=true;

}

    return(
        <>
        { show ===true &&
        <div><li>{service_cost > 0 && <>Scan cost: <span style={{ fontWeight: "bolder" }}>{service_cost}$. </span></>}
        {gap_cost > 0 && <> <span style={{ fontWeight: "bolder",color: "red" }}> {gap_cost}$</span> to be paid by Patient.</> }
        {additional_cost > 0 && <> Additional Cost on Saturday: <span style={{ fontWeight: "bolder",color: "red" }}>{additional_cost}$.</span></> }
        </li></div>  }
         </>
    )
}
const PatientNotes = ({ helpNotes }) => {
    
    return (<div style={{ display: "grid", gap: "2px", margin: "3px", padding: "3px", backgroundColor: "lightgoldenrodyellow" }}>
        {/* Costing */}
        
         <CheckHelpNotes helpNotes={helpNotes}/>
        
     

        {/* Fasting */}
        {helpNotes?.rules?.fasting_data?.text && <div><li>{helpNotes?.rules?.fasting_data?.text}</li></div>}
        {/* water intake*/}
        {helpNotes?.rules?.water_intake_data?.details && 
                <div><li>Water Intake Rules:</li>
                    <ul style={{marginBottom:"0px", listStyleType:"square"}}>
                        <li>Qty : <span style={{ fontWeight: "bolder" }}>{helpNotes?.rules?.water_intake_data?.details?.water_intake_quantity_in_ml}</span> ml</li>
                        <li>Empty Bladder : <span style={{ fontWeight: "bolder" }}>{helpNotes?.rules?.water_intake_data?.details?.bladder_empty_time_before_scan} mins</span> before scan</li>
                        <li>Start Drinking : <span style={{ fontWeight: "bolder" }}>{helpNotes?.rules?.water_intake_data?.details?.water_intake_start_time_before_scan} mins</span> before scan</li>
                        <li>Finish Drinking : <span style={{ fontWeight: "bolder" }}>{helpNotes?.rules?.water_intake_data?.details?.water_intake_end_time_before_scan} mins</span> before scan</li>
                    </ul>
                </div>
        }
        {/* early arrival */}
        {helpNotes?.rules?.early_arrival_data?.early_arrival_in_mins>0 && <div><li>Arrive early by <span style={{ fontWeight: "bolder" }}>{helpNotes?.rules?.early_arrival_data?.early_arrival_in_mins}</span> minutes</li></div>}
        {/* {""} */}
    </div>)
}
const BookingNotes = ({ helpNotes }) => {
    let availability_working_days = new Array();

    if (helpNotes?.rules?.availability_hours) {
        const working_days = helpNotes?.rules?.availability_hours[0].working_days.split(",");
        working_days.map((value) => {
            if (value === "-1") {
                availability_working_days.push("All buisness days")
            }
            if (value === "1") {
                availability_working_days.push("Monday")
            }
            if (value === "2") {
                availability_working_days.push("Tuesday")
            }
            if (value === "3") {
                availability_working_days.push("Wednesday")
            }
            if (value === "4") {
                availability_working_days.push("Thursday")
            }
            if (value === "5") {
                availability_working_days.push("Friday")
            }
            if (value === "6") {
                availability_working_days.push("Saturday")
            }
            if (value === "7") {
                availability_working_days.push("Sunday")
            }

        });

    }

    let roster_data = new Array();
    if(helpNotes?.rules?.sonographer_skillset_mapping_rule){
        helpNotes?.rules?.sonographer_skillset_mapping_rule.map(each=>{roster_data.push(each.roster_description)})
    }

    let allowed_rooms = new Array();
    if(helpNotes?.rules?.allowed_rooms_and_duration){
        helpNotes?.rules?.allowed_rooms_and_duration.map(each=>{allowed_rooms.push(each.room_name)})
    }
    let applicable_reserves = new Array();
    if(helpNotes?.rules?.comrad_reserves?.include_slots_for){
        helpNotes?.rules?.comrad_reserves?.include_slots_for.map(each=>{
            if(each.evaluate_rule_as === 1)
            {
                each.roster_text.map(each_roster_text=>{applicable_reserves.push(each_roster_text)})
            }
            if(each.evaluate_rule_as === 3)
            {
                each.roster_text.map(each_roster_text=>{applicable_reserves.push("*"+each_roster_text+"*")})
            }
        })
    }
    let foundIndex = applicable_reserves.findIndex(x => x == "__weekday__");
    if(foundIndex>=0)
    {
        applicable_reserves.splice(foundIndex,1)
        applicable_reserves.unshift("ANY OPEN RESERVE")
    }

    foundIndex = applicable_reserves.findIndex(x => x == "__roster_description__");
    if(foundIndex>=0)
    {
        applicable_reserves.splice(foundIndex,1)
        applicable_reserves.unshift("ANY OPEN RESERVE")
    }
    
    applicable_reserves = [...new Set(applicable_reserves)]

    console.log(roster_data)
    return (<div style={{ display: "grid", gap: "2px", margin: "3px", padding: "3px", backgroundColor: "lightblue" }}>
        {/* Provisional booking */}
        {helpNotes?.rules?.provisional_booking_data?.is_booking_provisional === true &&
        <li><span style={{color:"red"}}><b>Provisional appointment</b> only!</span></li>}
        {/* Appointment duration */}
        {helpNotes?.rules?.time_needed_for_procedure && <li><b>{helpNotes?.rules?.time_needed_for_procedure} minutes</b> appointment.</li>}{/* Avaialability day */}
        {helpNotes?.rules?.availability_hours && <li>Book on: <b>{availability_working_days.join(", ")}</b> between <b>{moment(helpNotes?.rules?.availability_hours[0].working_hours_from, 'h:mm a').format('h:mm a')}</b> &  <b>{moment(helpNotes?.rules?.availability_hours[0].working_hours_to, 'h:mm a').format('h:mm a')}</b>
        </li>}
        {/* roster */}
        {roster_data.length>0 && <li>Sonographers : {roster_data.join(", ")}</li>}
        {/* allowed rooms */}
        {allowed_rooms.length>0 && <li>Allowed Rooms : {allowed_rooms.join(", ")}</li>}
        {/* Reserves */}
        {applicable_reserves.length>0 && <li>Applicable reserves : {applicable_reserves.join(", ")}</li>}
    </div>)

}
const HelpNotes = ({ helpNotes }) => {
    if (helpNotes?.rules?.helpnotes?.length===0)
    {return (<div></div>)}
    return (<div style={{ display: "grid", gap: "2px", margin: "3px", padding: "3px", backgroundColor: "red",color:"white", fontSize:"16px", fontWeight:"bolder" }}>
        {/* help notes */}
        {helpNotes?.rules?.helpnotes?.length>0 && helpNotes.rules.helpnotes.map(txt => <li>{txt}</li>)}
    </div>)

}
const FlowDisplay = ({ helpNotes }) => {
    return (<div style={{borderWidth:"1px", borderColor:"gray", borderStyle:"outset"}}>
        {/* ServiceNotForBooking */}
        {isServiceNotApplicable({helpNotes})===true && <ServiceNotForBooking helpNotes={helpNotes}></ServiceNotForBooking>}
        {/* PatientNotes */}
        {isServiceNotApplicable({helpNotes})===false && <PatientNotes helpNotes={helpNotes}></PatientNotes>}
        {/* BookingNotes */}
       {isServiceNotApplicable({helpNotes})===false &&  <BookingNotes helpNotes={helpNotes}></BookingNotes>}

        {/* HelpNotes */}
        {isServiceNotApplicable({helpNotes})===false && <HelpNotes helpNotes={helpNotes}></HelpNotes>}

    </div>)
}


const OperatorGuideLines = ({ ui_view_type, helpNotes }) => {
    return (
        <FlowDisplay helpNotes={helpNotes}></FlowDisplay>
    );
};

export default OperatorGuideLines;